import styled from 'styled-components'

export const NavWrapper = styled.nav`
  width: 100%;
  background-color: ${p => p.theme.colors.navy};
  position: sticky;
  top: 0;
  left: auto;
  right: 0;
  z-index: 1100;
`

export const TopSide = styled.div`
  max-width: 1240px;
  margin-left: auto;
  margin-right: auto;
  height: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1200px) and (min-width: 600px) {
    justify-content: flex-end;
  }
  @media (max-width: 600px) {
    height: 80px;
  }
`

export const NavList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-grow: 0.3;
  @media screen and (max-width: 1200px) {
    display: none;
  }
`

export const SignIn = styled.div`
  @media (max-width: 1200px) {
    margin-right: 56px;
  }
  @media screen and (max-width: 600px) {
    display: none;
  }
`

export const Title = styled.div`
  color: ${p => p.theme.colors.white};
  font-size: 14px;
  margin: auto;
  @media screen and (min-width: 1025px) {
    font-size: 18px;
  }
`

export const Event = styled.span`
  font-weight: bold;
  @media screen and (max-width: 767px) {
    display: none;
  }
`

export const Logo = styled.img`
  width: 168px;
  @media screen and (max-width: 1200px) {
    position: absolute;
    top: 25px;
    left: 50px;
  }
  @media screen and (max-width: 600px) {
    position: absolute;
    top: 23px;
    left: 20px;
  }
`

export const AsideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background-color: ${p => p.theme.colors.white};
  transform: translateX(${p => (p.active ? 0 : -100)}%);
  transition: transform 0.3s linear;
`
export const SvgButtonWrapper = styled.button`
  padding: 0;
  background-color: transparent;
  border: 0;
  text-align: left;
  color: ${p => p.theme.colors.gray};
  cursor: pointer;
  &:focus {
    outline: none;
  }
`

export const CrossWrapper = styled.div`
  align-self: flex-end;
  padding-top: 30px;
  padding-right: 30px;
`

export const NavBarSubtitle = styled.div`
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 700;
  color: rgb(131, 111, 80);
  width: 100%;
  max-width: 300px;
  position: relative;
  margin: 45px 0 20px;
  &:after {
    content: '';
    border-bottom: 1px solid rgb(131, 111, 80);
    width: 100%;
    display: block;
  }
  span {
    display: block;
    background: #ffffff;
    position: absolute;
    top: -19px;
    left: 50%;
    padding: 10px;
    transform: translateX(-50%);
  }
`

export const HamburgerWrapper = styled.div`
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  padding-right: 50px;
  display: none;

  @media screen and (max-width: 1200px) {
    display: flex;
  }
  @media screen and (max-width: 600px) {
    padding-right: 30px;
    padding-top: 0px;
  }
`

export const AsideNavList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 15px;
`

export const StyledMenuWrapper = styled.div`
  .dropdown-menu {
    background-color: #ab9157;
  }
  .dropdown-item {
    background-color: #ab9157;
    color: #ffffff;
    a {
      text-decoration: none;
      color: inherit;
    }
  }
  .dropdown-divider {
    border-top: 1px solid #836f50;
  }
`
